var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":"Bedrooms","rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('Dropdown',{attrs:{"fieldId":'bedrooms' + _vm.idSuffix,"value":_vm.value,"error":errors[0],"options":_vm.bedroomOptions,"placeholder":"Select number of bedrooms","label":"Bedrooms"},on:{"input":_vm.onInput}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }